import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "../store"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useAuth = () => useAppSelector((state) => state.auth)

export const useSubDomain = () => {
  const host = window.location.hostname // e.g., "tata.developer.kwalee.com"
  const parts = host.split(".")

  if (parts.length > 1) {
    return { clientName: parts[0], isProVersion: true } // "tata"
  }
  return { clientName: parts, isProVersion: false }
}
